var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-wrapper"},[(_vm.imageUrl)?_c('img',{staticClass:"bg",style:({
      height: _vm.language == 'en-US' ? 'calc(8139 / 1080 * 100vw)' : 'calc(5903 / 1080 * 100vw)'
    }),attrs:{"src":_vm.imageUrl,"alt":""}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }